import { combineReducers } from '@reduxjs/toolkit'
import selected from './selected'

const viewBy = combineReducers({
  selected,
})

export type ViewBy = ReturnType<typeof viewBy>

export default viewBy
